import { useState } from 'react';
import { IconButton, IconName, Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { Reservation } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { ResourceName } from '../../../../components/reservation/ResourceName';
import ResourceSelectDialog from './ResourceSelectDialog';

interface ResourceSelectProps {
    startUtc: string;
    endUtc: string;
    requestedCategoryId: Reservation['requestedCategoryId'];
    assignedResourceId: Reservation['assignedResourceId'];
    reservationId: Reservation['id'];
    serviceId: string;
}

const ResourceSelect = ({
    startUtc,
    endUtc,
    assignedResourceId,
    serviceId,
    reservationId,
    requestedCategoryId,
}: ResourceSelectProps) => {
    const [isEditingResource, setEditingResource] = useState(false);

    return (
        <>
            <Stack spacing="100" itemAlignment="center">
                <ResourceName resourceId={assignedResourceId} notFoundElement={lt(TextKey.Assign)} />
                <IconButton
                    icon={IconName.Edit}
                    onClick={() => setEditingResource(true)}
                    size="small"
                    variant="ghost"
                    type="submit"
                />
            </Stack>
            <ResourceSelectDialog
                reservationId={reservationId}
                assignedResourceId={assignedResourceId}
                requestedCategoryId={requestedCategoryId}
                serviceId={serviceId}
                startUtc={startUtc}
                endUtc={endUtc}
                isEditingResource={isEditingResource}
                setEditingResource={setEditingResource}
            />
        </>
    );
};

export default ResourceSelect;
